var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopPanel',{attrs:{"noSearch":"","hideAdd":"","showCustomer":""}}),_c('div',{staticClass:"statistics-content-container"},[_c('Statistics')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }